import { render, staticRenderFns } from "./ISRDetails.vue?vue&type=template&id=008fec2f"
import script from "./ISRDetails.vue?vue&type=script&lang=js"
export * from "./ISRDetails.vue?vue&type=script&lang=js"
import style0 from "./ISRDetails.vue?vue&type=style&index=0&id=008fec2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports